import type { InsightsInsightsPageQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type CompaniesEmployeesPerLegalEntity =
  InsightsInsightsPageQuery['companies']['employeesPerLegalEntitiesConnection']['nodes'][number]

import { ExportRow, GenerateExport } from './export'

export default class EmployeesPerLegalEntity implements GenerateExport {
  private employeesPerLegalEntity: CompaniesEmployeesPerLegalEntity[]

  constructor(employeesPerLegalEntity: CompaniesEmployeesPerLegalEntity[]) {
    this.employeesPerLegalEntity = employeesPerLegalEntity
  }

  isEmpty() {
    return !this.employeesPerLegalEntity.length
  }

  export() {
    const data: ExportRow[][] = [
      [
        i18n.t('insights.widgets.employee_per_legal_entity.legal_entity'),
        i18n.t('insights.widgets.shared.headcount'),
      ],
    ]

    this.generate().forEach((record) => {
      data.push([record.legalName, record.count])
    })

    return { title: i18n.t('insights.widgets.employee_per_legal_entity.title'), data }
  }

  generate() {
    const employeesPerLegalEntity = this.employeesPerLegalEntity.map(({ count, legalName }) => {
      return { count, legalName }
    })

    return employeesPerLegalEntity
  }
}
